<template>
  <div class="page page-devices content">
    <h1 class="page__title">{{ str('devices.menuTitle') }}</h1>

    <LinkButton
      form="scanForNewDevices"
      :text="str('devices.scan')"
      @click.native="startScanning"
      :disable-on-submit="true"
      :submit="true"
      :icon-right="'Arrow'"
    />
    <DevicesList />
  </div>
</template>

<script>
  import LinkButton from '@/components/LinkButton'
  import DevicesList from '@/components/devices/DevicesList'

  export default {
    name: 'page-devices',
    components: {
      LinkButton,
      DevicesList,
    },
    methods: {
      startScanning() {
        this.$store.dispatch('scanForNewDevices')
      },
    },
  }
</script>

<style lang="scss">
  .page-devices {
    max-width: $content-page-width;
    position: relative;
  }

  .notice {
    padding-left: spacer(1);
    border-left: 3px solid $community;
  }
</style>
